import React from "react";
import { useOrganizationStore } from "../../../store";

function useOrganization() {
  const organization = useOrganizationStore((state) => state.organization);
  return React.useMemo(() => organization, [organization]);
}

export default useOrganization;
